import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import FunctionsIcon from "@material-ui/icons/Functions";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import SportsBasketballIcon from "@material-ui/icons/SportsBasketball";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100wh",
    
  },
  title:{
    display: "flex",
    justifyContent:'center',
    paddingTop:theme.spacing(5),
    paddingBottom:theme.spacing(5),
    fontSize:'50pt'
    
  },
  cards: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop:theme.spacing(25),
  },
  paper: {
    margin: theme.spacing(2),
    backgroundColor: "rgba(22, 33, 44, 0.8)",
    height: 180,
    width: 130,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "gray",
  },
  link: {
    height: 70,
    width: 50,
    color: "white",
  },
}));

function App() {
  const classes = useStyles();
  return (
    <Grid className={classes.root} spacing={2}>
      <Typography className={classes.title}> Projects </Typography>
      <Grid className={classes.cards}>
        <Paper className={classes.paper}>
          <a aria-label="Wiki" href="https://wiki.ramialkaro.fi">
            <AssignmentIcon className={classes.link} />
          </a>
          Wiki
        </Paper>
        <Paper className={classes.paper}>
          <a aria-label="calcaulator" href="https://calculator.ramialkaro.fi">
            <FunctionsIcon className={classes.link} />
          </a>
          Calculator
        </Paper>
        <Paper className={classes.paper}>
          <a aria-label="corona app" href="https://coronaapp.ramialkaro.fi">
            <LocalHospitalIcon className={classes.link} />
          </a>
          Corona app
        </Paper>
        <Paper className={classes.paper}>
          <a aria-label="corona app" href="https://hoppies.ramialkaro.fi">
            <SportsBasketballIcon className={classes.link} />
          </a>
          Hoppies
        </Paper>
        <Paper className={classes.paper}>
          <a aria-label="corona app" href="https://gametracker.ramialkaro.fi">
            <TrendingUpIcon className={classes.link} />
          </a>
          Gaming Tracker
        </Paper>
      </Grid>
    </Grid>
  );
}

export default App;
